(function() {
  'use strict';

  function initStickyContent() {
    const sections = document.querySelectorAll('.smart-mobility-content');

    if (window.innerWidth < 768) {
      return;
    }
    
    sections.forEach(section => {
      const leftContent = section.querySelector('.smart-mobility-content__content');
      const container = section.querySelector('.smart-mobility-content__container');
      const leftColumn = section.querySelector('.smart-mobility-content__left');
      
      if (!leftContent || !container || !leftColumn) return;
      
      let ticking = false;
      let isFixed = false;
      let sectionTop = 0;
      let sectionBottom = 0;
      let originalLeft = 0;
      let originalWidth = 0;
      let savedWidth = 0; // Store the width when it becomes fixed
      const stickyTop = 80; // offset from top (below navigation bar)
      
      function calculatePositions() {
        const rect = section.getBoundingClientRect();
        sectionTop = rect.top + window.scrollY;
        sectionBottom = sectionTop + section.offsetHeight;
        
        // Get the left position relative to viewport
        const leftColumnRect = leftColumn.getBoundingClientRect();
        originalLeft = leftColumnRect.left;
        
        // Only update originalWidth if not fixed (to preserve width when fixed)
        if (!isFixed) {
          originalWidth = leftColumnRect.width;
        }
      }
      
      function updateSticky() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            calculatePositions();
            
            const scrollY = window.scrollY;
            const contentHeight = leftContent.offsetHeight;
            
            // Calculate positions relative to viewport
            const sectionTopRelative = sectionTop - scrollY;
            const sectionBottomRelative = sectionBottom - scrollY;
            
            // Check if we should be sticky
            // Content should be sticky when:
            // 1. Section top has passed the sticky top position (we've scrolled into the section)
            // 2. Section bottom hasn't been reached yet (we're still within the section)
            // 3. There's enough space for the content (section bottom - content height >= sticky top)
            const isWithinSection = sectionTopRelative <= stickyTop && sectionBottomRelative > stickyTop;
            const hasEnoughSpace = (sectionBottomRelative - contentHeight) >= stickyTop;
            const shouldBeSticky = isWithinSection && hasEnoughSpace;
            
            if (shouldBeSticky && !isFixed) {
              // Save the width before making it fixed
              savedWidth = originalWidth;
              
              // Make it fixed
              isFixed = true;
              leftContent.style.position = 'fixed';
              leftContent.style.top = stickyTop + 'px';
              leftContent.style.left = originalLeft + 'px';
              leftContent.style.width = savedWidth + 'px';
              leftContent.style.maxWidth = savedWidth + 'px';
              leftContent.style.zIndex = '10';
              leftContent.classList.add('is-sticky');
            } else if (!shouldBeSticky && isFixed) {
              // Remove fixed - content will "hang" at bottom of section or return to normal
              isFixed = false;
              leftContent.style.position = '';
              leftContent.style.top = '';
              leftContent.style.left = '';
              leftContent.style.width = '';
              leftContent.style.maxWidth = '';
              leftContent.style.zIndex = '';
              leftContent.classList.remove('is-sticky');
            }
            
            // Update left position when fixed (but keep width the same)
            if (isFixed) {
              const leftColumnRect = leftColumn.getBoundingClientRect();
              leftContent.style.left = leftColumnRect.left + 'px';
              // Keep the saved width, don't update it
              leftContent.style.width = savedWidth + 'px';
              leftContent.style.maxWidth = savedWidth + 'px';
            }
            
            ticking = false;
          });
          ticking = true;
        }
      }
      
      // Initial calculation
      calculatePositions();
      
      // Listen to scroll and resize events
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', () => {
        // Reset saved width on resize so it can be recalculated
        if (isFixed) {
          savedWidth = 0;
          isFixed = false;
          leftContent.style.position = '';
          leftContent.style.top = '';
          leftContent.style.left = '';
          leftContent.style.width = '';
          leftContent.style.maxWidth = '';
          leftContent.style.zIndex = '';
          leftContent.classList.remove('is-sticky');
        }
        calculatePositions();
        updateSticky();
      }, { passive: true });
      
      // Initial check
      updateSticky();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyContent);
  } else {
    initStickyContent();
  }

  // Re-initialize on theme editor changes
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initStickyContent);
    document.addEventListener('shopify:section:reorder', initStickyContent);
  }
})();
